import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedEventState: cacheLs.get_event_state()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
